import React, { useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import '../Styles/AlertBar.css';

const ALERT_BAR_HEIGHT = 30; // Fixed height in pixels
const HEADER_HEIGHT = 50; // Approximate header height in pixels

const AlertBar = () => {
  const [alerts, setAlerts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    // Fetch the JSON file from S3
    fetch('https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/website_alerts.json')
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          setAlerts(data);
          setShowAlert(true);
          // Set CSS variables for positioning
          document.body.style.setProperty('--alert-bar-height', `${ALERT_BAR_HEIGHT}px`);
          document.body.style.setProperty('--total-header-height', `${ALERT_BAR_HEIGHT + HEADER_HEIGHT}px`);
        } else {
          // No alerts, set defaults
          document.body.style.setProperty('--alert-bar-height', '0px');
          document.body.style.setProperty('--total-header-height', `${HEADER_HEIGHT}px`);
        }
      })
      .catch(error => {
        console.error('Error fetching the JSON file:', error);
        // On error, set defaults
        document.body.style.setProperty('--alert-bar-height', '0px');
        document.body.style.setProperty('--total-header-height', `${HEADER_HEIGHT}px`);
      });
  }, []);

  const closeBar = useCallback(() => {
    setShowAlert(false);
    // Reset to default header height when alert is closed
    document.body.style.setProperty('--alert-bar-height', '0px');
    document.body.style.setProperty('--total-header-height', `${HEADER_HEIGHT}px`);
  }, []);

  if (!showAlert || alerts.length === 0) {
    return null;
  }

  return (
    <div className="alert-bar">
      <div className="alert-bar-container">
        <div className="alert-content">
          <div className="alert-scroll">
            {alerts.map((alert, index) => (
              <div
                key={index}
                className="alert-item"
                style={{ color: alert.font_color }}
              >
                {alert.text}
              </div>
            ))}
            {/* Duplicate alerts for seamless scrolling */}
            {alerts.map((alert, index) => (
              <div
                key={`duplicate-${index}`}
                className="alert-item"
                style={{ color: alert.font_color }}
              >
                {alert.text}
              </div>
            ))}
          </div>
        </div>
        <button
          type="button"
          className="alert-close-btn"
          onClick={closeBar}
          aria-label="Close alert"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default AlertBar;
